import { gql } from '@apollo/client';

export const CREATE_FACEBOOK_PAGE = gql`
  mutation updateFacebookPage($brandId: ID!) {
    updateFacebookPage(input: $input, id: $brandId)
      @rest(type: "Brand", path: "/v4/facebook-pages", method: "POST")
  }
`;
